const generatePath = (page, data) => page.split('/')
  .map((segment) => ((segment.includes(':')) ? data[segment.slice(1)] : segment))
  .join('/');

export default generatePath;
